import React, { createContext, useState, useEffect, useCallback, useMemo } from 'react';
import usePromociones from '../hooks/usePromociones';

// Crear el contexto con valores por defecto
export const PromocionesContext = createContext({
  promocionesAplicadas: [],
  totalDescuentos: 0,
  calculando: false,
  recalcularPromociones: () => { },
  verificarPromociones: () => ({ enPromocion: false, promociones: [] }),
  calcularTotales: () => ({ subtotal: 0, descuentos: 0, total: 0 }),
  productoTienePromocion: () => false,
  getInfoPromocionProducto: () => ({ tienePromocion: false }),
  detallesPromocionesT3: {}
});


/**
 * Proveedor del contexto de promociones
 * Permite que todos los componentes accedan a las funciones de promociones
 */
export const PromocionesProvider = ({ children, pedidoActual, promocionesDisponibles }) => {
  // Estado para guardar las promociones disponibles
  const [promocionesData, setPromocionesData] = useState(promocionesDisponibles || []);

  // Actualizar promocionesData si cambian las promocionesDisponibles
  useEffect(() => {
    if (promocionesDisponibles && Array.isArray(promocionesDisponibles)) {
      setPromocionesData(promocionesDisponibles);
    }
  }, [promocionesDisponibles]);

  // Usar el hook de promociones
  const {
    promocionesAplicadas,
    totalDescuentos,
    calculando,
    recalcularPromociones,
    verificarPromociones,
    calcularTotales,
    productoTienePromocion,
    getInfoPromocionProducto,
    detallesPromocionesT3
  } = usePromociones(pedidoActual, promocionesData);

  // Memoizar el valor del contexto para evitar renderizados innecesarios
  const value = useMemo(() => ({
    promocionesAplicadas,
    totalDescuentos,
    calculando,
    recalcularPromociones,
    verificarPromociones,
    calcularTotales,
    productoTienePromocion,
    getInfoPromocionProducto,
    detallesPromocionesT3
  }), [
    promocionesAplicadas,
    totalDescuentos,
    calculando,
    recalcularPromociones,
    verificarPromociones,
    calcularTotales,
    productoTienePromocion,
    getInfoPromocionProducto,
    detallesPromocionesT3
  ]);

  return (
    <PromocionesContext.Provider value={value}>
      {children}
    </PromocionesContext.Provider>
  );
};

export default PromocionesContext;